module.exports = __webpack_public_path__ + "img/stethoscope_off.26b0c103.gif";